import { Navigate, useLocation } from 'react-router-dom';
import AuthService from '../../../../shared/services/AuthService';
import { isMarketplaceBuyerRole } from '../../../../routes/roles';

export default function BuyerProtectedRoute({ children }) {
  const location = useLocation();
  if (!AuthService.isAuthenticated()) {
    return <Navigate to="/marketplace/account/login" replace state={{ from: location.pathname }} />;
  }
  if (!isMarketplaceBuyerRole(AuthService.getLoggedInRoleId())) {
    return <Navigate to="/unauthorized" replace />;
  }
  return children;
}
